import { CreateTypes } from 'canvas-confetti';

let instance: CreateTypes | null = null;

export const getInstance = (): CreateTypes | null => instance;

export const setInstance = (newInstance: CreateTypes | null): void => {
  instance = newInstance;
};
